// 4 piliers de services — DS Serrurier Urgence
//
// `detail` (prestations) et `description` alimentent la vue d'ensemble /services.
// `page` alimente la page dédiée /services/:slug — textes volontairement
// distincts de ceux de la vue d'ensemble et des pages ville (duplicate content).
// `page.tarifs` référence des lignes de TARIFS (tarifs.js) par leur libellé
// exact, pour que les prix restent définis à un seul endroit.

export const SERVICES = [
  {
    slug: "serrurerie-securite",
    id: "ouverture-porte",
    titre: "Serrurerie & Sécurité",
    tagline: "Urgence et prévention",
    icone: "Key",
    description:
      "Ouverture de porte claquée ou verrouillée, changement de serrure après effraction ou perte de clés, pose de cylindre A2P, blindage de porte d'entrée, portes blindées complètes.",
    prestations: [
      {
        id: "ouverture-porte",
        nom: "Ouverture de porte",
        detail: "Technique par crochetage sans dégât dans la majorité des cas. Ouverture d'urgence 7j/7.",
      },
      {
        id: "changement-serrure",
        nom: "Changement de serrure",
        detail: "Remplacement de serrure standard ou multi-points, avec cylindre A2P (niveau *, ** ou ***).",
      },
      {
        id: "blindage",
        nom: "Blindage de porte",
        detail: "Renforcement de porte existante par plaques d'acier, cornières anti-pinces, et cylindre haute sécurité.",
      },
      {
        id: "porte-blindee",
        nom: "Porte blindée",
        detail: "Pose de blocs-portes blindés certifiés (Fichet, Picard, Point Fort Fichet).",
      },
    ],
    image: "/images/services/serrurerie-securite.webp",
    imageWidth: 1264,
    imageHeight: 832,
    page: {
      seoTitle: "Serrurerie et sécurité en Île-de-France | DS Serrurier",
      seoDescription:
        "Serrurier 7j/7 en Île-de-France : ouverture de porte sans dégât, changement de serrure A2P, blindage et porte blindée. Prix annoncé avant de vous déplacer.",
      h1Accent: "ouverture, serrure, blindage",
      imageAlt: "Serrure de porte d'entrée remplacée par un serrurier DS Serrurier",
      heroIntro:
        "Porte claquée, clé perdue, serrure forcée ou simple envie de mieux protéger votre logement : nous intervenons en urgence 7j/7 et réalisons vos travaux de renforcement sur rendez-vous.",
      intro: [
        "La serrurerie représente l'essentiel de nos interventions. Deux situations très différentes s'y croisent : l'urgence, quand vous êtes bloqué dehors ou exposé après une effraction, et le projet, quand vous décidez de renforcer une porte avant qu'il ne soit trop tard. Dans les deux cas, la démarche est la même : comprendre votre porte et votre serrure avant de proposer quoi que ce soit.",
        "Depuis notre base de Puteaux, nous couvrons Paris et la petite couronne en priorité. Un ordre de prix vous est donné au téléphone avant le départ du technicien, et rien n'est engagé sur place sans votre accord.",
      ],
      situations: [
        {
          titre: "Porte claquée, clés à l'intérieur",
          texte: "Le cas le plus simple : la serrure n'est pas verrouillée, seul le pêne demi-tour retient la porte. L'ouverture se fait en général à la carte souple, en quelques minutes et sans laisser de trace.",
        },
        {
          titre: "Porte fermée à clé, clés perdues ou volées",
          texte: "Le crochetage reste la première option. Si les clés ont disparu avec vos papiers ou un document portant votre adresse, nous recommandons de changer le cylindre dans la foulée.",
        },
        {
          titre: "Après une tentative d'effraction",
          texte: "Cylindre arraché, porte voilée, gâche descellée : nous refermons l'accès le jour même et vous remettons les éléments utiles à votre déclaration d'assurance.",
        },
        {
          titre: "Serrure qui accroche, clé qui force",
          texte: "Signe d'usure ou de désalignement. Un réglage ou un remplacement du cylindre évite de rester bloqué au pire moment.",
        },
      ],
      methode: [
        {
          titre: "Vous décrivez la situation",
          texte: "Type de porte, de serrure, accès à l'immeuble : quelques questions suffisent pour estimer la durée d'intervention et vous donner un ordre de prix avant notre départ.",
        },
        {
          titre: "Nous ouvrons ou sécurisons",
          texte: "Carte souple, crochetage, puis remplacement du cylindre si nécessaire. Le perçage n'intervient qu'en dernier recours, et uniquement avec votre accord.",
        },
        {
          titre: "Nous vous conseillons pour la suite",
          texte: "Niveau A2P exigé par votre assurance, blindage ou bloc-porte : vous repartez avec une recommandation claire, sans obligation.",
        },
      ],
      prestationsTextes: {
        "ouverture-porte":
          "Une porte claquée s'ouvre presque toujours sans dégât. Pour une porte verrouillée, nous tentons d'abord le crochetage ; le remplacement du cylindre n'est proposé que si la serrure résiste ou présente un défaut mécanique.",
        "changement-serrure":
          "Après une perte de clés, un emménagement ou une effraction, nous remplaçons le cylindre seul ou la serrure complète, en posant un cylindre A2P adapté au niveau demandé par votre contrat d'assurance.",
        blindage:
          "Solution intermédiaire entre une porte standard et un bloc-porte neuf : tôle d'acier sur la face intérieure, cornières anti-pinces, protège-cylindre et serrure multipoints. Côté palier, la porte garde son aspect.",
        "porte-blindee":
          "Pour le niveau de protection le plus élevé, nous posons des blocs-portes blindés certifiés, livrés avec bâti et serrure intégrée. Prise de cotes et devis gratuits avant toute commande.",
      },
      tarifs: [
        "Ouverture de porte claquée",
        "Ouverture de porte fermée à clé",
        "Remplacement de pièces (cylindre, serrure...)",
        "Blindage de porte",
        "Déplacement",
      ],
      prixNote:
        "Prix indicatifs : le montant exact dépend de la serrure, de l'heure et du jour d'intervention. Il vous est toujours annoncé avant le déplacement.",
      faq: [
        {
          q: "Faut-il changer la serrure après une perte de clés ?",
          r: "Si les clés ont été perdues sans rien qui permette de retrouver votre adresse, ce n'est pas obligatoire, mais reste prudent. En cas de vol avec vos papiers, remplacez le cylindre au plus vite : c'est rapide et bien moins coûteux qu'un changement de serrure complet.",
        },
        {
          q: "Un locataire peut-il faire changer la serrure de son logement ?",
          r: "Oui, le locataire peut remplacer le cylindre à ses frais en cours de bail. À son départ, il remet l'ancien cylindre ou laisse les clés du nouveau au propriétaire. Pour un blindage ou une porte blindée, l'accord du propriétaire, voire de la copropriété, est nécessaire.",
        },
        {
          q: "Peut-on blinder une porte d'appartement en copropriété ?",
          r: "Oui. Le blindage se fixe sur la face intérieure de votre porte existante, ce qui préserve l'aspect du palier. Si le règlement de copropriété impose une teinte ou un modèle de porte, nous en tenons compte dans le devis.",
        },
      ],
      articles: [
        "normes-a2p-serrures-guide",
        "blindage-vs-porte-blindee",
        "que-faire-apres-une-effraction",
        "serrure-a2p-assurance-habitation",
        "securiser-serrure-avant-vacances-toussaint",
      ],
    },
  },
  {
    slug: "vitrerie",
    id: "vitrerie",
    titre: "Vitrerie",
    tagline: "Sécurisation et remplacement",
    icone: "Square",
    description:
      "Remplacement de vitre cassée, pose de vitrages retardateurs d'effraction (SP10, SP15), double vitrage isolant, miroirs, verre sur mesure. Sécurisation temporaire en cas d'effraction.",
    prestations: [
      {
        id: "vitre-brisee",
        nom: "Remplacement de vitre brisée",
        detail: "Intervention d'urgence, sécurisation immédiate, prise de mesures et pose du verre neuf.",
      },
      {
        id: "vitrage-securite",
        nom: "Vitrage retardateur d'effraction",
        detail: "Verres feuilletés SP10, SP15 pour renforcer une ouverture vulnérable.",
      },
      {
        id: "double-vitrage",
        nom: "Double vitrage isolant",
        detail: "Amélioration thermique et acoustique d'une menuiserie existante.",
      },
    ],
    image: "/images/services/vitrerie.webp",
    imageWidth: 1264,
    imageHeight: 832,
    page: {
      seoTitle: "Vitrier urgence vitre cassée Île-de-France | DS Serrurier",
      seoDescription:
        "Vitre cassée ou vitrine brisée en Île-de-France : mise en sécurité le jour même, remplacement sur mesure, vitrage feuilleté SP10/SP15 et double vitrage.",
      h1Accent: "vitre cassée & vitrage de sécurité",
      imageAlt: "Remplacement d'une vitre cassée par un vitrier DS Serrurier",
      heroIntro:
        "Fenêtre brisée après un cambriolage, baie vitrée fendue, vitrine de commerce endommagée : nous refermons l'ouverture immédiatement, puis remplaçons le verre aux bonnes dimensions.",
      intro: [
        "Une vitre cassée pose deux problèmes à la fois : le logement n'est plus fermé et les éclats restent dangereux. Notre première intervention consiste donc toujours à remettre l'ouverture hors d'air et hors d'eau et à retirer le verre brisé, avant de penser au remplacement.",
        "Le verre définitif est ensuite découpé sur mesure à partir de nos relevés. C'est aussi le bon moment pour se poser la question du niveau de protection : une fenêtre de rez-de-chaussée ou une porte-fenêtre sur cour mérite souvent mieux qu'un vitrage ordinaire.",
      ],
      situations: [
        {
          titre: "Vitre brisée par effraction",
          texte: "Nous posons une fermeture provisoire solide le jour même, puis remplaçons le vitrage. Photographiez les dégâts avant notre arrivée : votre assureur vous le demandera.",
        },
        {
          titre: "Vitrine ou porte vitrée de commerce",
          texte: "Une boutique ne peut pas rester ouverte aux quatre vents. Sécurisation rapide, puis pose d'un vitrage feuilleté adapté à l'exposition du local.",
        },
        {
          titre: "Double vitrage fendu ou embué",
          texte: "Une fissure ou de la buée entre les deux verres signale un vitrage qui a perdu son isolation. Remplacer le seul vitrage, sans toucher à la menuiserie, suffit dans bien des cas.",
        },
      ],
      methode: [
        {
          titre: "Mise en sécurité",
          texte: "Retrait des éclats et pose d'un panneau de protection pour refermer l'ouverture sans attendre le verre neuf.",
        },
        {
          titre: "Relevé des cotes",
          texte: "Mesure de la feuillure, de l'épaisseur et du type de vitrage d'origine, pour commander exactement le bon verre.",
        },
        {
          titre: "Pose du vitrage neuf",
          texte: "Remplacement, calage et jointoiement, avec une option de verre feuilleté retardateur si l'ouverture est exposée.",
        },
      ],
      prestationsTextes: {
        "vitre-brisee":
          "Intervention d'urgence pour refermer l'ouverture le jour même, puis pose d'un verre neuf découpé aux dimensions exactes de votre menuiserie.",
        "vitrage-securite":
          "Le verre feuilleté associe plusieurs couches de verre et de film plastique : même brisé, il reste en place et retarde le passage. Indiqué pour les rez-de-chaussée, vitrines et portes vitrées.",
        "double-vitrage":
          "Remplacement d'un simple vitrage ou d'un double vitrage défaillant sur une menuiserie existante, pour gagner en confort thermique et atténuer le bruit de la rue.",
      },
      prixNote:
        "Le prix d'un vitrage dépend de ses dimensions, de son épaisseur et de son type (simple, feuilleté, isolant). Le devis est établi après relevé des cotes ; la mise en sécurité d'urgence est chiffrée au téléphone.",
      faq: [
        {
          q: "Mon assurance prend-elle en charge une vitre cassée ?",
          r: "La plupart des contrats habitation couvrent le bris de glace, parfois en option. Après une effraction, c'est en général la garantie vol qui s'applique. Conservez la facture et les photos des dégâts : elles vous seront demandées.",
        },
        {
          q: "Que signifient SP10 et SP15 ?",
          r: "Ce sont deux niveaux de verre feuilleté retardateur d'effraction, correspondant aux classes P6B et P7B de la norme EN 356. Le SP15, plus épais, résiste plus longtemps aux coups répétés que le SP10.",
        },
        {
          q: "Peut-on remplacer la vitre sans changer la fenêtre ?",
          r: "Oui, dans la grande majorité des cas. Seul le vitrage est remplacé si la menuiserie (bois, PVC ou aluminium) est en bon état et que sa feuillure peut accueillir l'épaisseur du nouveau verre.",
        },
      ],
      articles: ["que-faire-apres-une-effraction"],
    },
  },
  {
    slug: "volets-roulants",
    id: "volets",
    titre: "Volets roulants",
    tagline: "Dépannage et motorisation",
    icone: "Blinds",
    description:
      "Dépannage de volet bloqué, remplacement de lames, changement de moteur, motorisation d'un volet manuel, pose de volets neufs sur mesure.",
    prestations: [
      {
        id: "volet-bloque",
        nom: "Dépannage volet bloqué",
        detail: "Diagnostic sur place, déblocage, remise en marche ou plan de réparation.",
      },
      {
        id: "moteur-volet",
        nom: "Changement de moteur",
        detail: "Remplacement de moteur tubulaire, filaire ou radio, sur volet existant.",
      },
      {
        id: "motorisation",
        nom: "Motorisation de volet manuel",
        detail: "Transformation d'un volet à sangle ou manivelle en volet motorisé.",
      },
    ],
    image: "/images/services/volets-roulants.webp",
    imageWidth: 1264,
    imageHeight: 832,
    page: {
      seoTitle: "Dépannage volet roulant Île-de-France | DS Serrurier",
      seoDescription:
        "Volet roulant bloqué ou moteur en panne en Île-de-France : diagnostic sur place, déblocage, changement de moteur et motorisation de volets manuels.",
      h1Accent: "dépannage & motorisation",
      imageAlt: "Volets roulants d'une maison dépannés par DS Serrurier",
      heroIntro:
        "Volet coincé à mi-hauteur, moteur qui ne répond plus, lames sorties des coulisses : nous diagnostiquons la panne sur place et remettons votre volet en service, ou vous proposons de le motoriser.",
      intro: [
        "Un volet bloqué fermé plonge une pièce dans le noir ; bloqué ouvert, il laisse une fenêtre sans protection pour la nuit. Dans les deux cas, mieux vaut ne pas forcer : la plupart des dégâts importants viennent d'une tentative de remontée à la main.",
        "Nos techniciens interviennent sur les volets manuels (sangle, manivelle) comme motorisés (filaire ou radio). Le diagnostic permet de distinguer une simple lame déboîtée d'une vraie panne de moteur, et donc d'éviter un remplacement inutile.",
      ],
      situations: [
        {
          titre: "Volet bloqué ouvert ou fermé",
          texte: "Lame cassée, attache rompue, axe déboîté : nous identifions la cause avant de débloquer, pour ne pas abîmer le tablier.",
        },
        {
          titre: "Moteur silencieux ou qui force",
          texte: "Alimentation, inverseur, télécommande ou moteur en fin de vie : chaque piste est vérifiée avant de conclure à un remplacement.",
        },
        {
          titre: "Sangle ou manivelle cassée",
          texte: "Panne fréquente sur les volets manuels. C'est souvent l'occasion de passer à la motorisation, qui supprime définitivement ces pièces d'usure.",
        },
      ],
      methode: [
        {
          titre: "Diagnostic",
          texte: "Test de la commande, de l'alimentation et du moteur, contrôle du tablier et des coulisses.",
        },
        {
          titre: "Déblocage ou réparation",
          texte: "Remise en place des lames, changement des attaches, de la sangle ou du treuil selon la panne constatée.",
        },
        {
          titre: "Remplacement si nécessaire",
          texte: "Moteur tubulaire neuf dimensionné pour le poids du tablier, ou motorisation d'un volet manuel, avec réglage des fins de course.",
        },
      ],
      prestationsTextes: {
        "volet-bloque":
          "Déblocage d'un tablier coincé, remise en place des lames sorties des coulisses, remplacement des attaches ou des lames abîmées.",
        "moteur-volet":
          "Remplacement d'un moteur tubulaire hors service par un modèle filaire ou radio adapté à votre volet, avec programmation des fins de course.",
        motorisation:
          "Dans la plupart des cas, un volet à sangle ou à manivelle se motorise sans changer le coffre ni le tablier. Commande murale, télécommande ou centralisation de plusieurs volets.",
      },
      prixNote:
        "Un déblocage simple et un changement de moteur n'ont pas le même coût : le prix dépend de la panne et du modèle de volet. Estimation au téléphone, puis devis ferme après diagnostic.",
      faq: [
        {
          q: "Peut-on remonter à la main un volet électrique bloqué ?",
          r: "Mieux vaut éviter. Forcer un tablier motorisé peut endommager le moteur ou les attaches. Coupez l'alimentation et faites établir un diagnostic : la cause est souvent plus simple qu'il n'y paraît.",
        },
        {
          q: "Moteur filaire ou radio : lequel choisir ?",
          r: "Le moteur filaire se commande par un interrupteur mural câblé, simple et robuste. Le moteur radio fonctionne avec une télécommande ou une commande sans fil, et permet de centraliser ou de programmer plusieurs volets. Le choix dépend surtout de l'installation électrique existante.",
        },
        {
          q: "Faut-il changer tout le volet quand le moteur lâche ?",
          r: "Non. Si le tablier et le coffre sont en bon état, seul le moteur est remplacé. Le changement complet ne se justifie que si le tablier est déformé ou les coulisses endommagées.",
        },
      ],
      articles: ["motoriser-volets-roulants-rentabilite"],
    },
  },
  {
    slug: "controle-acces",
    id: "controle-acces",
    titre: "Contrôle d'accès",
    tagline: "Immeubles, bureaux, commerces",
    icone: "ShieldCheck",
    description:
      "Digicodes, interphones, VIGIK, badges, ventouses électromagnétiques, gâches électriques, portails motorisés. Pour copropriétés, entreprises et commerces.",
    prestations: [
      {
        id: "digicode",
        nom: "Digicode & interphone",
        detail: "Pose ou remplacement de digicode, platine d'interphone audio ou vidéo.",
      },
      {
        id: "vigik",
        nom: "Système VIGIK",
        detail: "Mise en place et gestion des badges VIGIK pour immeubles.",
      },
      {
        id: "organigramme",
        nom: "Cylindre organigramme",
        detail: "Système de clés hiérarchisées pour tertiaire (passe partiel, passe général).",
      },
      {
        id: "gache",
        nom: "Gâche électrique & ventouse",
        detail: "Motorisation d'un accès existant, ventouse magnétique pour portes coupe-feu.",
      },
    ],
    image: "/images/services/controle-acces.webp",
    imageWidth: 1264,
    imageHeight: 832,
    page: {
      seoTitle: "Contrôle d'accès, digicode et VIGIK en IDF | DS Serrurier",
      seoDescription:
        "Contrôle d'accès pour copropriétés, bureaux et commerces en Île-de-France : digicode, interphone, VIGIK, badges, gâche électrique et ventouse. Devis gratuit.",
      h1Accent: "copropriétés, bureaux, commerces",
      imageAlt: "Digicode et lecteur de badge installés à l'entrée d'un immeuble",
      heroIntro:
        "Digicode en panne, interphone muet, badges perdus, porte de hall qui ne se verrouille plus : nous installons et dépannons les équipements qui filtrent l'entrée de votre immeuble ou de vos locaux.",
      intro: [
        "Le contrôle d'accès concerne surtout les syndics, conseils syndicaux, gestionnaires de bureaux et commerçants. L'enjeu n'est pas seulement de fermer une porte, mais de décider qui peut l'ouvrir, à quel moment, et comment retirer un accès quand un badge disparaît ou qu'un salarié quitte l'entreprise.",
        "Nous intervenons sur les halls d'immeuble, portes de parking, accès de service et locaux tertiaires, en dépannage comme en installation neuve. Pour une copropriété, le devis est rédigé pour pouvoir être présenté tel quel au conseil syndical ou en assemblée générale.",
      ],
      situations: [
        {
          titre: "Porte de hall qui reste ouverte",
          texte: "Ventouse qui ne tient plus, gâche électrique défaillante, ferme-porte déréglé : l'immeuble reste accessible à tous tant que la panne n'est pas réglée.",
        },
        {
          titre: "Badges perdus ou résident qui déménage",
          texte: "Les badges concernés sont désactivés et de nouveaux badges programmés, sans toucher au reste de l'installation.",
        },
        {
          titre: "Locaux avec plusieurs niveaux d'accès",
          texte: "Bureaux, réserve, local technique : un organigramme de clés ou un système de badges donne à chacun uniquement les accès dont il a besoin.",
        },
      ],
      methode: [
        {
          titre: "Repérage des accès",
          texte: "Inventaire des portes, du câblage existant et des usages : résidents, prestataires, livreurs, salariés.",
        },
        {
          titre: "Proposition chiffrée",
          texte: "Matériel adapté à la configuration, présenté de façon à être compris et voté par un conseil syndical ou une direction.",
        },
        {
          titre: "Installation et mise en service",
          texte: "Pose, programmation, remise des badges ou des codes, et prise en main expliquée au gestionnaire.",
        },
      ],
      prestationsTextes: {
        digicode:
          "Remplacement d'un clavier vandalisé, pose d'un digicode neuf ou d'une platine d'interphone audio ou vidéo reliée aux logements.",
        vigik:
          "Le VIGIK permet aux services autorisés (La Poste, prestataires) d'entrer dans les parties communes sans clé dédiée, tout en gardant la main sur les badges des résidents.",
        organigramme:
          "Un seul jeu de clés hiérarchisé : chaque salarié ouvre ses portes, le responsable ouvre tout. En cas de perte, seul le cylindre concerné est repris.",
        gache:
          "Électrification d'une porte existante par gâche électrique ou ventouse magnétique, raccordée à un digicode, un lecteur de badge ou un bouton de sortie.",
      },
      prixNote:
        "Chaque installation dépend du nombre de portes, du câblage existant et du nombre d'utilisateurs : nous chiffrons gratuitement après visite des lieux.",
      faq: [
        {
          q: "Qui décide d'installer un contrôle d'accès en copropriété ?",
          r: "L'installation ou le remplacement d'un système d'accès aux parties communes est en principe voté en assemblée générale. Pour un simple dépannage, le syndic peut commander l'intervention directement.",
        },
        {
          q: "Que faire quand la porte du hall ne ferme plus ?",
          r: "Prévenez le syndic ou le gestionnaire, qui peut commander un dépannage. En attendant, évitez de caler la porte ou de démonter la ventouse : la panne vient souvent de l'alimentation ou d'un réglage, que nous vérifions en priorité.",
        },
        {
          q: "Un organigramme de clés convient-il à une petite entreprise ?",
          r: "Oui, dès quelques portes et quelques salariés. Il évite de multiplier les trousseaux et limite le coût d'une perte de clé, puisqu'un seul cylindre est à reprendre.",
        },
      ],
      articles: [],
    },
  },
];

export const findService = (slug) => SERVICES.find((s) => s.slug === slug);
